import { Button } from '@/components/shadcn/button'
import { cn } from '@/lib/utils'
import { DEFAULT_MD_TEXT_SEARCH_MATCH_LIMIT } from './mdDocumentModel'
import { IconArrowDownOutline } from '@icons/IconArrowDownOutline'
import { IconArrowUpOutline } from '@icons/IconArrowUpOutline'

export function MdTextSearchNavigator({
  hasSearchTerm,
  matchCount,
  activeMatchIndex,
  onPrevious,
  onNext,
  className,
}: {
  hasSearchTerm: boolean
  matchCount: number
  activeMatchIndex: number
  onPrevious: () => void
  onNext: () => void
  className?: string
}) {
  if (!hasSearchTerm) {
    return null
  }

  return (
    <div
      className={cn(
        'absolute right-4 top-4 z-10 flex items-center gap-1 rounded-md border bg-background/95 px-2 py-1 text-xs shadow-sm backdrop-blur',
        className
      )}
    >
      <span className="min-w-20 text-center text-muted-foreground">
        {matchCount === 0
          ? 'No results'
          : `Search results: ${activeMatchIndex + 1} of ${matchCount}${matchCount >= DEFAULT_MD_TEXT_SEARCH_MATCH_LIMIT ? '+' : ''}`}
      </span>
      <Button
        variant="ghost"
        size="icon-sm"
        type="button"
        onClick={onPrevious}
        disabled={matchCount === 0}
        aria-label="Previous search result"
      >
        <IconArrowUpOutline size={14} />
      </Button>
      <Button
        variant="ghost"
        size="icon-sm"
        type="button"
        onClick={onNext}
        disabled={matchCount === 0}
        aria-label="Next search result"
      >
        <IconArrowDownOutline size={14} />
      </Button>
    </div>
  )
}
